import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_of_the_above_4'

export const dataPointDefinition = {
  retracedId: 'none_of_the_above_4',
  name: 'None of the above',
  description:
    'Select "X" for None of the above if the facility HAS a minimum of all practices described, i.e. facility has signed copies of contracts, contracts clear and accurate, etc. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-24x',
      number: 'RH-EMP-14-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'rh-emp-19',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],ep-3--2,Yes',
      machineShowHide: '[2],ep-3--2,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-24x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34520,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
